import { X } from 'lucide-react';
import { Button } from '../ui/button';

export const DeleteModal = ({ isOpen, onClose, onConfirm, type = 'comment' }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4" onClick={onClose}>
      <div 
        className="glass-panel rounded-2xl p-6 border max-w-sm w-full"
        onClick={(e) => e.stopPropagation()}
        style={{ background: '#1a1a1a', border: '1px solid rgba(212, 175, 55, 0.3)' }}
      >
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-bold">Delete {type}?</h3>
          <button onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        <p className="text-sm text-gray-400 mb-6">
          Are you sure you want to delete this {type}? This action cannot be undone.
        </p>
        <div className="flex gap-3 justify-end">
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button 
            onClick={onConfirm}
            style={{ background: '#ef4444', color: '#fff' }}
          >
            Delete
          </Button>
        </div>
      </div>
    </div>
  );
};
